import { css } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { tablet } from '../utils';

export const styles = css`
  :host {
    display: flex;
    flex-direction: column;
  }

  ${tablet(css`
    :host {
      flex-direction: row;
    }

    ::slotted(uc-footer-menu-toggle:nth-of-type(1)) {
      flex: 1 1 25%;
      padding-right: ${pxToRem(10)};
    }

    ::slotted(uc-footer-menu-toggle:nth-of-type(2)) {
      flex: 1 1 45%;
      padding-right: ${pxToRem(10)};
      padding-left: ${pxToRem(10)};
      border-left: 1px dashed #ddd;
    }

    ::slotted(uc-footer-menu-toggle:nth-of-type(3)) {
      flex: 1 1 30%;
      padding-left: ${pxToRem(10)};
      border-left: 1px dashed #ddd;
    }
  `)}
`;
